import React from "react";
import styles from "./Login.module.scss";
import Button from "components/Button/Button";
import LoginLayout from "./LoginLayout";
import SignIn from "./SignIn/SignIn";
import LostPassword from "./LostPassword/LostPassword";
import DropdownSignUp from "./DropdownSignUp/DropdownSignUp";
import logos from "assets/images/canaleducacao/Logotipos-Canal-Acerela-Seduc.png";
import { useParams } from "react-router-dom";

function Login() {
  const { link, connection } = useParams();

  return (
    <LoginLayout>
      <div className={styles.body}>
        <div className={styles.btnGroup}>
          <Button
            modifiers={["outline", "full"]}
            anchor
            to={
              link && connection ? `/entrar/${link}/${connection}` : "/entrar"
            }
          >
            Entrar com meu email
          </Button>
        </div>
      </div>

      <div className={styles.footer}>
        <Button
          modifiers={["review", "full"]}
          anchor
          to={
            link && connection
              ? `/criar-uma-conta/${link}/${connection}/consulta-de-dados`
              : "/criar-uma-conta/consulta-de-dados"
          }
        >
          Criar uma conta nova
        </Button>

        <br />
        <img src={logos} alt="Logos" />
      </div>
    </LoginLayout>
  );
}

export { Login as default, SignIn, LostPassword, LoginLayout };
